import { processHtmlAttributes } from "../../common/html-attributes/index.js";
$ const {
  name,
  class: inputClass,
  borderless,
  disabled,
  fluid,
  invalid,
  buttonName,
  option: options = [],
  truncate,
  prefixLabel,
  prefixId,
  postfixLabel,
  unselectedText = "-",
  floatingLabel,
  collapseOnSelect,
  listSelection,
  variant,
  hasError,
  strategy,
  flip,
  split = "none",
  a11yIconPrefixText,
  a11ySelectedText = "selected",
  ariaDescribedby: describedby,
  ...htmlInput
} = input;
$ var selectedOption = [...(options || [])][state.selectedIndex];
$ var selectedText = selectedOption && selectedOption.text;
$ var selectedIcon = selectedOption && selectedOption.icon;
$ var a11ySelectedIconText = selectedIcon && selectedOption && selectedOption.text;
$ var labelId = prefixId && component.getElId("label");
$ var displayText = selectedText || unselectedText;
$ var isForm = variant === "form";
<macro|{
  alwaysDisplay
}| name="render-text">
  <if(selectedIcon)>
    <span id=labelId class="btn__text">
      <${selectedIcon}/>
    </span>
  </if>
  <else-if(selectedText || alwaysDisplay)>
    <span id=labelId class="btn__text">
      ${displayText}
      <if(postfixLabel)>
        <span class="btn__postfix-label">
          ${` ${postfixLabel}`}
        </span>
      </if>
    </span>
  </else-if>
</macro>
<${truncate && !fluid ? "div" : "span"} ...processHtmlAttributes(htmlInput) key="container" class=["listbox-button", inputClass, fluid && "listbox-button--fluid", isForm && `listbox-button--form`, hasError && "listbox-button--error"] on-expander-expand("handleExpand") on-expander-collapse("handleCollapse")>
  <button key="button" class=["listbox-button__control", "btn", split !== "none" && `btn--split-${split}`, borderless ? "btn--borderless" : "btn--form", truncate && "btn--truncated", floatingLabel && "btn--floating-label"] aria-label=(a11ySelectedIconText && `${a11yIconPrefixText}: ${a11ySelectedIconText}`) value=selectedText type="button" disabled=disabled name=buttonName aria-haspopup="listbox" aria-describedby=describedby aria-labelledby=(labelId && `${prefixId} ${labelId}`) aria-invalid=(invalid && "true")>
    <span class="btn__cell">
      <if(floatingLabel)>
        <span class=["btn__floating-label", "btn__floating-label--animate", !selectedText && "btn__floating-label--inline"]>
          ${floatingLabel}
        </span>
        <render-text/>
      </if>
      <else-if(prefixLabel)>
        <span class="btn__label">
          ${prefixLabel}
        </span>
        <render-text always-display/>
      </else-if>
      <else>
        <render-text always-display/>
      </else>
      <ebay-chevron-down-16-icon/>
    </span>
  </button>
  <ebay-listbox key="options" class=["listbox-button__listbox", strategy === "fixed" && "listbox-button__listbox--fixed"] name=name tabindex=-1 listSelection=listSelection a11ySelectedText=a11ySelectedText onChange("handleListboxChange") onEscape("handleListboxEscape")>
    <for|option| of=(options || [])>
      <@option ...option selected=(selectedOption === option)/>
    </for>
  </ebay-listbox>
</>